/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines */
/* eslint-disable no-underscore-dangle */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import isEmpty from 'lodash/isEmpty';
import { call, all, put, select, take, takeLatest, fork } from 'redux-saga/effects';
import {
  callEddService,
  submitShipping,
  validateAdress,
  loadShipmentMethods,
  getTransSmsSubscriptionStateSaga,
} from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.saga';

import constants, {
  DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY,
} from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import submitBilling from '@tcp/core/src/components/features/CnC/Checkout/container/CheckoutBilling.saga';
import BagPageActions from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import {
  fetchDefaultShipmentMethods,
  getSetIsPaypalPaymentSettings,
  getSetPickupAltValuesActn,
  getSetPickupValuesActn,
  isExpressCallThroughPlccICFailure,
  setIsUpdatingShipmentMethods,
  setSMSUpdatesActn,
} from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.action';
import { getAppleClientTokenData } from '@tcp/core/src/components/features/CnC/Checkout/container/CheckoutApple.selector.js';
import { clearEddTTL } from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.actions';
import {
  callUpdateRTPS,
  updateShipping,
} from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.saga.util';
import { getGiftWrapOptionsData } from '@tcp/core/src/components/features/CnC/Checkout/container/CheckoutCommon.saga';
import { isApplePayEligible, parseBoolean } from '@tcp/core/src/utils/utils';
import { fetchPaySecureSessionIdSaga } from '@tcp/core/src/components/features/CnC/Checkout/container/CheckoutBilling.saga.util';
import { getModuleX } from '@tcp/core/src/services/abstractors/common/moduleX';
import {
  removeSessionStorage,
  routerPush,
  setSessionStorage,
  getBasketId,
  setValueInAsyncStorage,
  getAPIConfig,
  isCanada,
  getSessionStorage,
} from '@tcp/core/src/utils';
import { getAddressListState } from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.selectors.js';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { moveSFSItemsToSFL } from '@tcp/core/src/services/abstractors/CnC/CheckoutSFCC.js';
import {
  multiDeviceEnabled,
  getIsDefaultApplePayAbTest,
  getOrderTrackingEnhancementEnabled,
  getGiftServiceOnBagSection,
  getSuppressCvvField,
  getSMSUpdatesSingleOptInEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { resetAfterPayPayload } from '@tcp/core/src/components/common/organisms/AddressVerification/container/AddressVerification.actions';
import { getAfterPayPayload } from '@tcp/core/src/components/common/organisms/AddressVerification/container/AddressVerification.selectors';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import { submitEmailSignup } from '@tcp/core/src/components/features/CnC/Checkout/container/CheckoutExtended.saga.util.js';
import isAppleWalletSetUp from '../../Checkout/container/applepay.utils';
import { setLoaderState } from '../../../../common/molecules/Loader/container/Loader.actions';
import { verifyAddress } from '../../../../common/organisms/AddressVerification/container/AddressVerification.actions';
import { getAddressList } from '../../../account/AddressBook/container/AddressBook.saga';
import {
  getUserEmail,
  getUserLoggedInState,
  getUserPhoneNumber,
} from '../../../account/User/container/User.selectors';
import CheckoutSelector, {
  isGuest,
  isExpressCheckout,
  getLoginV2FlowEnabled,
  isExpressCallDoneThroughPlccIcFailure,
  getPickupValues,
} from '../../Checkout/container/Checkout.selector';
import {
  ADDRESS_FORM_MODE,
  REG_FORM_MODE,
  SHIPPING_FORM_NAME,
} from './Shipping/Shipping.constants';
import startCheckoutAnalytics from './SinglePageCheckoutAnalytics.util';
import { formatPayloadForMelissa, setShippingFormValuesInSS } from './Shipping/Shipping.utils';
import {
  recalibrateSectionStates,
  toggleSPC,
  updateSectionState,
  setCvvInfoModuleX,
  setGiftDetailsModalContentModuleX,
  setSpcButtonLoader,
  setSectionAnchoring,
  updateMultipleSectionStates,
  setShowAddressVerification,
  updateSubmitOrderButtonState,
  setSFSErrors,
  moveItemToSFLToggle,
  showShippingMethodsInCollapsed,
  triggerCheckoutWithPayment,
  toggleVerifyCvvModal,
  setSuppressCCheck,
} from './SinglePageCheckout.actions';
import {
  INIT_EDD,
  INIT_SINGLE_PAGE_CHECKOUT_PAGE,
  RECALIBRATE_SECTIONS_STATES,
  SAVE_ADDRESS_FROM_MELISSA,
  SAVE_AND_CONTINUE_PAYMENT,
  SAVE_AND_CONTINUE_SHIPPING,
  SECTION_MODE,
  SPC_SECTION,
  FETCH_CVV_MODULE_X,
  FETCH_GIFT_DETAIL_MODAL_MODULE_X,
  SUBMIT_ORDER_WITH_PAYMENT,
  SPC_BUTTON,
  SAVE_SPC_CONTACT,
  ACTIVATE_SPC_SECTION,
  SUBMIT_ORDER_BUTTON_STATE,
  ADD_EDIT_STORE_DETAILS,
  ADD_SFS_ITEMS_TO_SFL,
} from './SinglePageCheckout.constants';
import {
  checkIsContactDetailsSaved,
  checkIsPaymentSectionSaved,
  getShippingSectionSavedStatus,
  getSinglePageCheckoutSectionState,
  isCvvVisibleOnViewMode,
  shouldReverifyCvv,
  shouldSkipPayment,
  getExpandedSectionName,
  checkIsPickupDetailsSaved,
  getDefaultAddress,
  getSfsError,
  getSavedContactDetails,
  getTriggerCheckoutWithPayment,
  getPaymentId,
  checkDefaultAfterPayEnabled,
  getIsExtendedPreOrderForSPC,
} from './SinglePageCheckout.selector';
import logger from '../../../../../utils/loggerInstance';
import { handleShippingError } from '../../Checkout/container/CheckoutShipping.saga';
import submitOrderForProcessing from '../../Checkout/container/CheckoutReview.saga';
import { CONTACT_FORM } from '../molecules/ContactForm/ContactForm.constant';
import { setServerErrorCheckout } from '../../Checkout/container/Checkout.action.util';
import {
  addPerformanceMarksForSection,
  deStructureAddress,
  extractMonthAndYear,
  getSavedShippingValues,
  getShippingPayloadForSubmit,
  getContactFormInitValues,
  callPersistData,
  setAfterPayPaymentmethod,
} from './SinglePageCheckout.saga.util';
import {
  checkContactFormValuesInSS,
  getContactFormValuesFromSS,
  setContactFormValuesInSS,
} from '../molecules/ContactForm/ContactForm.util';
import {
  getNonCachedCartDataSaga,
  processMutationNonCachedDataSaga,
  getCachedCartDataSaga,
  resetCartCache,
} from '../../BagPage/container/BagPage.saga';
import BAG_PAGE_ACTIONS, {
  isPlccIsPickupModalOpen,
  setSflId,
  setSubmitButtonState,
  setApplePayDefault,
} from '../../BagPage/container/BagPage.actions';
import BAG_PAGE_SELECTORS, {
  getOrderType,
  isECOMStatus,
  isMixedOrderStatus,
  isPickuOrderStatus,
  isPersistEddGlobalEnabled,
} from '../../BagPage/container/BagPage.selectors';
import BAGPAGE_CONSTANTS from '../../BagPage/BagPage.constants';
import { validateCache } from '../../../../../utils/cache.util';
import {
  BILLING_FORM_VISIBLE,
  SHIPPING_FORM_VISIBLE,
  SUBMIT_ORDER_BUTTON_VISIBLE,
} from '../../../../../constants/rum.constants';
import { addEditStoreDetailsApi } from '../../../../../services/abstractors/SFCC/addEditStoreDetails';
import {
  getCardList,
  getAddressAndCardListSaga,
} from '../../../account/Payment/container/Payment.saga';
import { getAddressAndCardListActionTriggeredThroughSPC } from '../../../account/Payment/container/Payment.actions';
import { getAddressCardListActionTriggeredThroughSPCSelector } from '../../../account/Payment/container/Payment.selectors';
import { isVenmoNonceActive } from '../../Checkout/container/CheckoutVenmo.selector';
import AddressVerificationDynamicStore from '../../../../common/organisms/AddressVerification/container/AddressVerificationDynamicStore';
import { readCookie, setCookie } from '../../../../../utils/cookie.util';
import { getOrderShipments } from '../../CartItemTile/container/CartItemTile.selectors';

function* initEdd({ payload }) {
  const { orderId, skuData, zipCode, state, isEDD, isEditing, eddAllowedStatesArr } = payload;
  const initEddPayload = {
    orderId,
    skuList: skuData,
    zipCode,
    state,
    isEDD,
    isEditing,
    eddAllowedStatesArr,
  };
  yield call(callEddService, initEddPayload);
}

export function* fetchPaySecureSessionId({ payload }) {
  try {
    const { id, section } = payload;
    if (
      id === SPC_SECTION.PAYMENT &&
      section.mode === SECTION_MODE.SECTION_ADD_MODE &&
      section.isExpanded
    ) {
      yield call(fetchPaySecureSessionIdSaga);
    }
  } catch (e) {
    logger.error(e);
  }
}

function* updateAllSectionStates({
  contactSection = {},
  shippingSection = {},
  paymentSection = {},
  pickupSection = {},
  myBagSection = {},
}) {
  yield put(
    updateMultipleSectionStates([
      {
        id: SPC_SECTION.CONTACT,
        section: contactSection,
      },
      {
        id: SPC_SECTION.SHIPPING,
        section: shippingSection,
      },
      {
        id: SPC_SECTION.PICKUP,
        section: pickupSection,
      },
      {
        id: SPC_SECTION.PAYMENT,
        section: paymentSection,
      },
      {
        id: SPC_SECTION.MY_BAG,
        section: myBagSection,
      },
    ])
  );
}

export function* activateSpcSection({ payload }) {
  const { id } = payload;
  const { isShippingSectionSaved } = yield select(getShippingSectionSavedStatus);
  const isPaymentSectionSaved = yield select(checkIsPaymentSectionSaved);
  const isShippingSectionActive = SPC_SECTION.SHIPPING === id;
  const isPickUpSectionActive = SPC_SECTION.PICKUP === id;
  const isPaymentSectionActive = SPC_SECTION.PAYMENT === id;
  const contactSection = {
    isExpanded: SPC_SECTION.CONTACT === id,
    isActive: false,
  };
  const shippingSection = {
    isExpanded: isShippingSectionActive,
    isActive: false,
  };
  const paymentSection = {
    isExpanded: SPC_SECTION.PAYMENT === id,
    isActive: false,
    disabled: !isPaymentSectionSaved,
  };
  const pickupSection = {
    isExpanded: isPickUpSectionActive,
    isActive: false,
  };
  if (!isShippingSectionActive && !isShippingSectionSaved) {
    shippingSection.disabled = true;
  }
  if (!isPaymentSectionActive && !isPaymentSectionSaved) {
    paymentSection.disabled = true;
  }

  yield call(updateAllSectionStates, {
    contactSection,
    shippingSection,
    pickupSection,
    paymentSection,
  });
}

const handleModeTransition = (savedSection) => {
  return savedSection ? SECTION_MODE.SECTION_VIEW_MODE : SECTION_MODE.SECTION_ADD_MODE;
};

// const isMixedOrder = (isBopisOrder, isEcomOrder) => {
//   return isBopisOrder && isEcomOrder;
// };

const handleVariedTransitions = ({
  isPaymentSectionSaved,
  isEcomOrder,
  isContactDetailsSaved,
  isShippingSectionSaved,
  isPickupSectionSaved,
  isMixedOrder,
  isBossBopisOrder,
}) => {
  let isPaymentExpanded = false;
  const paymentSection = {};
  const pickupSection = {};
  const paymentSectionMode = handleModeTransition(isPaymentSectionSaved);
  if (isEcomOrder) {
    isPaymentExpanded = isContactDetailsSaved && isShippingSectionSaved && !isPaymentSectionSaved;
    paymentSection.disabled = !isContactDetailsSaved || !isShippingSectionSaved;
  }
  if (isBossBopisOrder) {
    isPaymentExpanded = isContactDetailsSaved && isPickupSectionSaved && !isPaymentSectionSaved;
    paymentSection.disabled = !isContactDetailsSaved || !isPickupSectionSaved;

    pickupSection.disabled = !isContactDetailsSaved;
    pickupSection.isExpanded = !isPickupSectionSaved && isContactDetailsSaved;
    pickupSection.mode = handleModeTransition(isPickupSectionSaved);
  }
  if (isMixedOrder) {
    isPaymentExpanded =
      isContactDetailsSaved &&
      isPickupSectionSaved &&
      isShippingSectionSaved &&
      !isPaymentSectionSaved;
    paymentSection.disabled =
      !isContactDetailsSaved || !isPickupSectionSaved || !isShippingSectionSaved;

    pickupSection.disabled = !isShippingSectionSaved;
    pickupSection.isExpanded =
      isContactDetailsSaved && isShippingSectionSaved && !isPickupSectionSaved;
    pickupSection.mode = handleModeTransition(isPickupSectionSaved);
  }
  paymentSection.isExpanded = isPaymentExpanded;
  paymentSection.mode = paymentSectionMode;
  paymentSection.isPaymentMethodExpanded = false;

  return {
    paymentSection,
    pickupSection,
  };
};

function* updateSectionStateOnGetCart() {
  // Select isSaved  status for each state
  const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);
  let isContactDetailsSaved = true;
  if (!isLoginV2FlowEnabled) {
    isContactDetailsSaved = yield select(checkIsContactDetailsSaved);
  }

  const { isShippingAddressSaved, isShippingSectionSaved } = yield select(
    getShippingSectionSavedStatus
  );
  const isPickupSectionSaved = yield select(checkIsPickupDetailsSaved);
  const isPaymentSectionSaved = yield select(checkIsPaymentSectionSaved);
  const isReverifyCvv = yield select(shouldReverifyCvv);

  // Compute nextState for each section
  const myBagSection = { isExpanded: false };
  const contactSection = { isExpanded: !isContactDetailsSaved };
  const isEcomOrder = yield select(isECOMStatus);
  const isMixedOrder = yield select(isMixedOrderStatus);
  const isBossBopisOrder = yield select(isPickuOrderStatus);
  const shippingSection = {
    disabled: !isContactDetailsSaved,
    isExpanded: isContactDetailsSaved && !isShippingSectionSaved,
    mode: handleModeTransition(isShippingSectionSaved),
  };
  if (!isShippingSectionSaved && isShippingAddressSaved) {
    shippingSection.autoSuggestMode = ADDRESS_FORM_MODE.MANUAL;
  }
  const { paymentSection, pickupSection } = handleVariedTransitions({
    isPaymentSectionSaved,
    isEcomOrder,
    isContactDetailsSaved,
    isShippingSectionSaved,
    isPickupSectionSaved,
    isMixedOrder,
    isBossBopisOrder,
  });
  // Put nextState for each section
  yield call(updateAllSectionStates, {
    contactSection,
    shippingSection,
    paymentSection,
    pickupSection,
    myBagSection,
  });

  // Set isActive status for anchoring to active card
  yield put(
    setSectionAnchoring({
      [SPC_SECTION.CONTACT]: !isContactDetailsSaved,
      [SPC_SECTION.SHIPPING]: !!(
        shippingSection.isExpanded ||
        (isContactDetailsSaved && isShippingSectionSaved && isPaymentSectionSaved && !isReverifyCvv)
      ),
      [SPC_SECTION.PAYMENT]: !!(paymentSection.isExpanded || isReverifyCvv),
    })
  );

  // Initiates a pay-secure session call on Payment section expansion
  yield call(fetchPaySecureSessionId, {
    payload: { id: SPC_SECTION.PAYMENT, section: paymentSection },
  });
}

function* initContactForm() {
  const reduxState = yield select();
  const contactSectionData = getSinglePageCheckoutSectionState()(reduxState, SPC_SECTION.CONTACT);
  const isContactFormSavedInSS = checkContactFormValuesInSS(contactSectionData);

  const shippingContactInfo = yield select(CheckoutSelector.getShippingContactInfo);
  if (!isContactFormSavedInSS && !isEmpty(shippingContactInfo?.emailAddress)) {
    setSessionStorage({ key: CONTACT_FORM, value: JSON.stringify(shippingContactInfo) });
  }

  // Init section state for contact form values
  yield put(
    updateSectionState({
      id: SPC_SECTION.CONTACT,
      section: getContactFormInitValues({
        isContactFormSavedInSS,
        shippingContactInfo,
        contactFormValuesFromSS: getContactFormValuesFromSS(contactSectionData),
      }),
    })
  );
}

function* checkDefaultShipmentMethodsNeeded() {
  const defaultAddress = yield select(getDefaultAddress);
  const { isShippingAddressSaved } = yield select(getShippingSectionSavedStatus);
  const shipmentMethods = yield select(CheckoutSelector.getShipmentMethods);
  if (!isShippingAddressSaved && !(shipmentMethods && shipmentMethods.length)) {
    yield put(fetchDefaultShipmentMethods({ ...defaultAddress, pageEvent: 'SPC' }));
  }
}

function* analyticsOnCheckoutPage(currentStage) {
  const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);
  const isBossBopisOrder = yield select(isPickuOrderStatus);
  const orderType = yield select(getOrderType);
  if (!currentStage) {
    let allFunnelSteps = [...constants.CHECKOUT_STAGES.STAGES_ARRAY];
    if (orderType === 'PURE_BOSS' || orderType === 'PURE_BOPIS') {
      allFunnelSteps = allFunnelSteps.filter((funnelStep) => funnelStep !== 'shipping');
    } else if (orderType === 'PURE_ECOM') {
      allFunnelSteps = allFunnelSteps.filter((funnelStep) => funnelStep !== 'pickup');
    }
    for (let i = 0; i < allFunnelSteps.length; i += 1) {
      const checkoutStage = allFunnelSteps[i];
      yield call(startCheckoutAnalytics, checkoutStage, true, isLoginV2FlowEnabled);
    }
  } else if (currentStage === SPC_SECTION.CONTACT) {
    yield call(
      startCheckoutAnalytics,
      constants.CHECKOUT_STAGES.CONTACT_INFO,
      true,
      isLoginV2FlowEnabled
    );
  } else if (currentStage === SPC_SECTION.SHIPPING && !isBossBopisOrder) {
    yield call(
      startCheckoutAnalytics,
      constants.CHECKOUT_STAGES.SHIPPING,
      true,
      isLoginV2FlowEnabled
    );
  } else if (currentStage === SPC_SECTION.PAYMENT) {
    const { isShippingSectionSaved } = yield select(getShippingSectionSavedStatus);
    if (isShippingSectionSaved) {
      yield call(
        startCheckoutAnalytics,
        constants.CHECKOUT_STAGES.SHIPPING,
        true,
        isLoginV2FlowEnabled
      );
    }
    yield call(
      startCheckoutAnalytics,
      constants.CHECKOUT_STAGES.BILLING,
      true,
      isLoginV2FlowEnabled
    );
  } else if (
    currentStage === SPC_SECTION.PICKUP ||
    (isBossBopisOrder && currentStage === SPC_SECTION.SHIPPING)
  ) {
    yield call(
      startCheckoutAnalytics,
      constants.CHECKOUT_STAGES.PICKUP,
      true,
      isLoginV2FlowEnabled
    );
    const pickUpContactPerson = yield select(getPickupValues);
    const isPickupSectionSaved = !isEmpty(pickUpContactPerson?.firstName);
    if (isPickupSectionSaved) {
      yield call(
        startCheckoutAnalytics,
        constants.CHECKOUT_STAGES.BILLING,
        true,
        isLoginV2FlowEnabled
      );
    }
    const isPaymentSectionSaved = yield select(checkIsPaymentSectionSaved);
    if (isPaymentSectionSaved) {
      yield call(
        startCheckoutAnalytics,
        constants.CHECKOUT_STAGES.REVIEW,
        true,
        isLoginV2FlowEnabled
      );
    }
  } else {
    yield call(
      startCheckoutAnalytics,
      constants.CHECKOUT_STAGES.REVIEW,
      true,
      isLoginV2FlowEnabled
    );
  }
}

const checkReqFields = (savedAddress) => {
  const {
    address1,
    city,
    countryCode,
    postalCode,
    stateCode,
    c_emailId: emailId,
  } = savedAddress || {};
  return address1 && city && countryCode && postalCode && stateCode && emailId;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export function* initSinglePageCheckout({ payload }) {
  try {
    // TODO: Need to rework on Estmitation Tax TTL implementation
    // const estimatedTax = getSessionStorage('estimatedTax');
    // const estimatedTaxReduxTTLValue = yield select(estimatedTaxReduxTTL);
    // yield put(BAG_PAGE_ACTIONS.setEstimatedTax({ tax: estimatedTax, estimatedTaxReduxTTLValue }));
    yield put(toggleSPC({ isSPC: true }));
    const isLoggedIn = yield select(getUserLoggedInState);
    const isExpressCheckoutEnabled = yield select(isExpressCheckout);
    yield put(moveItemToSFLToggle(false));
    const isCachedCartReduxExist = yield validateCache({
      type: BAGPAGE_CONSTANTS.GET_CACHED_CART_DATA,
    });
    const isMultiDeviceEnabled = yield select(multiDeviceEnabled);
    if (isMultiDeviceEnabled || !isCachedCartReduxExist) {
      yield call(getCachedCartDataSaga, { payload });
    }
    const itemsCount = yield select(BAG_PAGE_SELECTORS.getTotalItems);
    if (itemsCount === 0 && window?.location?.href?.includes('checkout')) {
      routerPush('/bag', '/bag');
      return;
    }

    const isNonCachedCartReduxExist = yield validateCache({
      type: BAGPAGE_CONSTANTS.GET_NON_CACHED_CART_DATA,
    });
    yield put(setSFSErrors(null));
    const sfsErrorFromGetInventory = JSON.parse(getLocalStorage('sfsError'));
    if (sfsErrorFromGetInventory) {
      yield put(setSFSErrors(sfsErrorFromGetInventory));
    }

    const isExpressDoneThroughPlccIcFailure = yield select(isExpressCallDoneThroughPlccIcFailure);
    if (
      isNonCachedCartReduxExist &&
      isExpressCheckoutEnabled &&
      !isExpressDoneThroughPlccIcFailure
    ) {
      yield put(isExpressCallThroughPlccICFailure(false));
      yield call(getNonCachedCartDataSaga, {
        payload: {
          ...payload,
          disableLoading: true,
        },
      });
    }
    if (!isNonCachedCartReduxExist && !isExpressDoneThroughPlccIcFailure) {
      yield put(isExpressCallThroughPlccICFailure(false));
      const dataPayload = { ...payload, disableLoading: false };
      yield put(BAG_PAGE_ACTIONS.getNonCachedCartData(dataPayload));
      yield take(BAGPAGE_CONSTANTS.GET_NON_CACHED_CART_DATA_COMPLETED);
    }
    const isGetPaymentAndAddressAPITriggered = yield select(
      getAddressCardListActionTriggeredThroughSPCSelector
    );
    const checkoutShippingAddress = yield select(CheckoutSelector.getShippingAddress);
    const pickUpContactPerson = yield select(getPickupValues);

    const shipmentId = yield select(getOrderShipments);
    const isSMSUpdatesSingleOptInEnabled = yield select(getSMSUpdatesSingleOptInEnabled);

    const orderType = yield select(getOrderType);

    const isMixedOrder = orderType === 'ECOM_MIX';
    const isBossBopisOrder = orderType === 'PURE_BOSS' || orderType === 'PURE_BOPIS';
    const isEcomOrder = orderType === 'PURE_ECOM';

    const isNumberPresent =
      (checkoutShippingAddress && checkoutShippingAddress?.phone && isEcomOrder) ||
      (pickUpContactPerson && pickUpContactPerson?.phoneNumber && isBossBopisOrder) ||
      (checkoutShippingAddress && checkoutShippingAddress?.phone) ||
      (pickUpContactPerson && pickUpContactPerson?.phoneNumber && isMixedOrder);

    if (!isNumberPresent && isSMSUpdatesSingleOptInEnabled) {
      setCookie({
        key: 'smsSubscriptionStatus',
        value: false,
      });
      setCookie({
        key: 'subscribedPhoneNumber',
        value: null,
      });
      setCookie({
        key: 'unsubscribedPhoneNumber',
        value: null,
      });
    }
    if (isNumberPresent && isSMSUpdatesSingleOptInEnabled) {
      const normalizedShippingPhoneNumber = checkoutShippingAddress?.phone?.replace(/\D/g, '');
      const normalizedPickupPhoneNumber = pickUpContactPerson?.phoneNumber?.replace(/\D/g, '');

      let shippingPhoneNumberValue = normalizedShippingPhoneNumber;

      const pickUpPhoneNumberValue = normalizedPickupPhoneNumber;

      const store = shipmentId?.filter((data) => {
        if (data?.shipmentId !== 'me' && data?.itemsCount > 0) {
          return data;
        }
        return null;
      });

      const [shipment = {}] = shipmentId;
      const [pickUpShipment = {}] = store;

      const shipmentEcomIdValue = shipment?.shipmentId;
      const shipmentBopisIdValue = pickUpShipment?.shipmentId;

      const subscribedPhoneNumber = readCookie('subscribedPhoneNumber');
      const unsubscribedPhoneNumber = readCookie('unsubscribedPhoneNumber') || false;
      const smsSubscriptionStatus = parseBoolean(readCookie('smsSubscriptionStatus')) || false;

      let smsSubscriptionState;
      const subscribedNewPhoneNumberShipping =
        (shippingPhoneNumberValue &&
          shippingPhoneNumberValue !== subscribedPhoneNumber &&
          shippingPhoneNumberValue !== unsubscribedPhoneNumber) ||
        (unsubscribedPhoneNumber &&
          shippingPhoneNumberValue &&
          shippingPhoneNumberValue !== unsubscribedPhoneNumber &&
          !smsSubscriptionStatus);
      const subscribedNewPhoneNumberPickUp =
        (pickUpPhoneNumberValue &&
          pickUpPhoneNumberValue !== subscribedPhoneNumber &&
          pickUpPhoneNumberValue !== unsubscribedPhoneNumber) ||
        (unsubscribedPhoneNumber &&
          pickUpPhoneNumberValue &&
          pickUpPhoneNumberValue !== unsubscribedPhoneNumber &&
          !smsSubscriptionStatus);

      const isUSorCaCountryCode =
        shipment?.shippingAddress?.c_phoneCountryCode === '+1' ||
        shipment?.shippingAddress?.c_phoneCountryCode === null ||
        shipment?.shippingAddress?.c_phoneCountryCode === undefined;

      const isUSorCaCountryCodePickup =
        pickUpShipment?.shippingAddress?.c_phoneCountryCode === '+1' ||
        pickUpShipment?.shippingAddress?.c_phoneCountryCode === null ||
        pickUpShipment?.shippingAddress?.c_phoneCountryCode === undefined;

      if (shippingPhoneNumberValue && !isBossBopisOrder && isUSorCaCountryCode) {
        if (subscribedNewPhoneNumberShipping) {
          let smsResponse = yield call(getTransSmsSubscriptionStateSaga, shippingPhoneNumberValue);
          smsSubscriptionState = smsResponse?.data?.getTransSmsSubscriptionState?.status;

          if (
            isMixedOrder &&
            !smsSubscriptionState &&
            pickUpPhoneNumberValue &&
            isUSorCaCountryCodePickup
          ) {
            smsResponse = yield call(getTransSmsSubscriptionStateSaga, pickUpPhoneNumberValue);
            smsSubscriptionState = smsResponse?.data?.getTransSmsSubscriptionState?.status;
            if (smsSubscriptionState) {
              shippingPhoneNumberValue = pickUpPhoneNumberValue;
            }
          }

          setCookie({
            key: 'smsSubscriptionStatus',
            value: smsSubscriptionState,
          });

          if (smsSubscriptionState) {
            setCookie({
              key: 'subscribedPhoneNumber',
              value: shippingPhoneNumberValue,
            });
            setCookie({
              key: 'unsubscribedPhoneNumber',
              value: null,
            });
          } else {
            setCookie({
              key: 'unsubscribedPhoneNumber',
              value: shippingPhoneNumberValue,
            });
          }
        }

        const numberChanged = subscribedPhoneNumber
          ? subscribedPhoneNumber !== shippingPhoneNumberValue
          : false;

        const optimizedPayload = [
          {
            shipmentId: shipmentEcomIdValue,
            c_vibesSmsPhoneNo: shippingPhoneNumberValue,
          },
        ];

        // call sms order updates api when number is changed but this also is subscribed, we need to send this new number to Vibes
        if (numberChanged && smsSubscriptionState) {
          yield put(setSMSUpdatesActn(optimizedPayload));
        }
      } else if (
        pickUpPhoneNumberValue &&
        subscribedNewPhoneNumberPickUp &&
        isUSorCaCountryCodePickup
      ) {
        const smsResponsePickUp = yield call(
          getTransSmsSubscriptionStateSaga,
          pickUpPhoneNumberValue
        );
        smsSubscriptionState = smsResponsePickUp?.data?.getTransSmsSubscriptionState?.status;

        setCookie({
          key: 'smsSubscriptionStatus',
          value: smsSubscriptionState,
        });

        if (smsSubscriptionState) {
          setCookie({
            key: 'subscribedPhoneNumber',
            value: pickUpPhoneNumberValue,
          });
          setCookie({
            key: 'unsubscribedPhoneNumber',
            value: null,
          });
        } else {
          setCookie({
            key: 'unsubscribedPhoneNumber',
            value: pickUpPhoneNumberValue,
          });
        }
        const optimizedPayload = [
          {
            shipmentId: shipmentBopisIdValue,
            c_vibesSmsPhoneNo: pickUpPhoneNumberValue || '',
          },
        ];
        const numberChanged = subscribedPhoneNumber
          ? subscribedPhoneNumber !== pickUpPhoneNumberValue
          : false;

        // call sms order updates api when number is changed but this also is subscribed, we need to send this new number to Vibes
        if (numberChanged && subscribedPhoneNumber && smsSubscriptionState) {
          yield put(setSMSUpdatesActn(optimizedPayload));
        }
      }
    }

    const isGuestUser = yield select(isGuest);

    if (!isGuestUser || isLoggedIn) {
      if (!isGetPaymentAndAddressAPITriggered) {
        yield call(getAddressAndCardListSaga);
      } else {
        yield put(getAddressAndCardListActionTriggeredThroughSPC(false));
      }
      const getAllAddressList = yield select(getAddressListState);
      const addressList = JSON.parse(JSON.stringify(getAllAddressList));
      const savedAddress = addressList?.find(
        (index) =>
          (index?.preferred === 'true' && checkReqFields(index)) ||
          (index?.c_addressType === 'ShippingAndBilling' && checkReqFields(index)) ||
          (index?.c_addressType === 'Billing' && checkReqFields(index))
      );
      const savedBillingAddress = addressList?.filter(
        (index) =>
          index?.c_addressType?.includes('Billing') && index?.xcont_isDefaultBilling === 'true'
      );
      const isVenmoInProgress = yield select(CheckoutSelector.isVenmoPaymentInProgress);
      const rtpsBillingAddress =
        savedBillingAddress && savedBillingAddress.length && savedBillingAddress[0];
      let rtpsAddress = savedAddress;
      let rtpsAddressLine1 = savedAddress?.address1;
      let rtpsAddressLine2 = savedAddress?.address2;
      let rtpsCountry = savedAddress?.countryCode;
      let rtpsState = savedAddress?.stateCode;
      let rtpsZip = savedAddress?.postalCode;
      let rtpsCity = savedAddress?.city;
      let rtpsPhone = savedAddress?.phone;
      let rtpsEmailAddress = savedAddress?.c_emailId;
      let rtpsAddressObject = {
        ...rtpsAddress,
        addressLine1: rtpsAddressLine1,
        addressLine2: rtpsAddressLine2,
        city: rtpsCity,
        country: rtpsCountry,
        state: rtpsState,
        zipCode: rtpsZip,
      };
      if (!isExpressCheckoutEnabled) {
        yield put(
          updateSectionState({
            id: SPC_SECTION.CONTACT,
            section: { isExpanded: false },
          })
        );

        const { isPaypalPostBack = false } = payload;
        if (!isPaypalPostBack && !isEmpty(savedAddress) && checkReqFields(savedAddress)) {
          const {
            address1,
            address2,
            addressId,
            c_addressType: addressType,
            c_emailId: emailId,
            c_validationCode: validationCode,
            phoneCountryCode,
            city,
            countryCode,
            firstName,
            lastName,
            phone,
            postalCode,
            stateCode,
          } = savedAddress || {};
          const {
            addressLine1,
            addressLine2,
            city: shippingCity,
            state: shippingState,
            zipCode: shippingZipCode,
          } = checkoutShippingAddress || {};
          yield call(loadShipmentMethods, {
            state: shippingState || stateCode,
            city: shippingCity || city,
            addressField1: addressLine1 || address1,
            addressField2: addressLine2 || address2,
            zipCode: shippingZipCode || postalCode,
            country: countryCode,
          });
          const getAllShipmentMethods = yield select(CheckoutSelector.getShipmentMethods);
          const getSavedShippingMethod = yield select(CheckoutSelector.getSavedShippingMethod);
          const shippingMethodDto = {
            shippingMethod: {
              id: getSavedShippingMethod?.shippingMethodId || getAllShipmentMethods[0]?.id,
            },
          };
          const loggedInUserEmail = yield select(getUserEmail);
          const loggedInUserPhone = yield select(getUserPhoneNumber);
          const shippingPayload = {
            ...shippingMethodDto,
            shippingAddressDTO: {
              c_vibesSmsPhoneNo: '',
              c_deliveryIndicator: '1',
              shippingAddress: {
                address1,
                address2,
                c_addressId: addressId,
                c_addressType: addressType,
                c_emailAddress: loggedInUserEmail || emailId,
                c_validationCode: validationCode,
                city,
                countryCode,
                firstName,
                lastName,
                phone: phone || loggedInUserPhone,
                postalCode,
                stateCode,
              },
            },
          };
          if (phoneCountryCode) {
            shippingPayload.shippingAddressDTO.shippingAddress.c_phoneCountryCode =
              phoneCountryCode;
          }
          try {
            const isEmailIdFound = loggedInUserEmail || emailId;

            if (
              getAllAddressList?.size > 0 &&
              isEmailIdFound &&
              countryCode === getAPIConfig()?.country &&
              (!checkoutShippingAddress ||
                (!checkoutShippingAddress?.addressLine1 && isSMSUpdatesSingleOptInEnabled))
            ) {
              const res = yield call(updateShipping, shippingPayload);
              const { data: { updateShipping: updateShippingRes } = {} } = res;
              yield call(processMutationNonCachedDataSaga, {
                payload: {
                  respToProcess: updateShippingRes,
                  isCheckoutFlow: true,
                  ignoreCache: false,
                },
              });
              if (isSMSUpdatesSingleOptInEnabled) {
                const [shipment = {}] = updateShippingRes?.shipments;

                // eslint-disable-next-line sonarjs/no-identical-functions
                const store = updateShippingRes?.shipments?.filter((data) => {
                  if (data?.shipmentId !== 'me' && data?.itemsCount > 0) {
                    return data;
                  }
                  return null;
                });
                const [shipmentPickup = {}] = store;
                const normalizedPhoneNumberPickUp = shipmentPickup?.shippingAddress?.phone?.replace(
                  /\D/g,
                  ''
                );

                const normalizedPhoneNumber = shipment?.shippingAddress?.phone?.replace(/\D/g, '');

                let phoneNumberValue = normalizedPhoneNumber;
                const shipmentIdValue = shipment?.shipmentId;

                const subscribedPhoneNumber = readCookie('subscribedPhoneNumber');
                const unsubscribedPhoneNumber = readCookie('unsubscribedPhoneNumber') || false;
                const smsSubscriptionStatus =
                  parseBoolean(readCookie('smsSubscriptionStatus')) || false;

                const isUSorCaCountryCode =
                  shipment?.shippingAddress?.c_phoneCountryCode === '+1' ||
                  shipment?.shippingAddress?.c_phoneCountryCode === null ||
                  shipment?.shippingAddress?.c_phoneCountryCode === undefined;

                const isUSorCaCountryCodePickup =
                  shipmentPickup?.shippingAddress?.c_phoneCountryCode === '+1' ||
                  shipmentPickup?.shippingAddress?.c_phoneCountryCode === null ||
                  shipmentPickup?.shippingAddress?.c_phoneCountryCode === undefined;

                const pickUpNumber = isUSorCaCountryCodePickup ? normalizedPhoneNumberPickUp : null;

                phoneNumberValue =
                  !isUSorCaCountryCode && isMixedOrder ? pickUpNumber : phoneNumberValue;

                const subscribedNewPhoneNumber =
                  (phoneNumberValue !== subscribedPhoneNumber &&
                    phoneNumberValue !== unsubscribedPhoneNumber) ||
                  (unsubscribedPhoneNumber &&
                    phoneNumberValue !== unsubscribedPhoneNumber &&
                    !smsSubscriptionStatus);

                if (
                  smsSubscriptionStatus &&
                  !isUSorCaCountryCode &&
                  !isUSorCaCountryCodePickup &&
                  isSMSUpdatesSingleOptInEnabled
                ) {
                  setCookie({
                    key: 'smsSubscriptionStatus',
                    value: false,
                  });
                }

                if (subscribedNewPhoneNumber && isSMSUpdatesSingleOptInEnabled) {
                  let smsResponse = yield call(getTransSmsSubscriptionStateSaga, phoneNumberValue);
                  let smsSubscriptionState =
                    smsResponse?.data?.getTransSmsSubscriptionState?.status;

                  if (
                    isMixedOrder &&
                    !smsSubscriptionState &&
                    normalizedPhoneNumberPickUp &&
                    isUSorCaCountryCodePickup
                  ) {
                    smsResponse = yield call(
                      getTransSmsSubscriptionStateSaga,
                      normalizedPhoneNumberPickUp
                    );
                    smsSubscriptionState = smsResponse?.data?.getTransSmsSubscriptionState?.status;
                    if (smsSubscriptionState) {
                      phoneNumberValue = normalizedPhoneNumberPickUp;
                    }
                  }

                  setCookie({
                    key: 'smsSubscriptionStatus',
                    value: smsSubscriptionState,
                  });

                  if (smsSubscriptionState) {
                    setCookie({
                      key: 'subscribedPhoneNumber',
                      value: phoneNumberValue,
                    });
                    setCookie({
                      key: 'unsubscribedPhoneNumber',
                      value: null,
                    });
                  } else {
                    setCookie({
                      key: 'unsubscribedPhoneNumber',
                      value: phoneNumberValue,
                    });
                  }

                  const optimizedPayload = {
                    shipmentId: shipmentIdValue,
                    c_vibesSmsPhoneNo: phoneNumberValue || '',
                  };
                  const numberChanged = subscribedPhoneNumber
                    ? subscribedPhoneNumber !== phoneNumberValue
                    : false;

                  if (subscribedNewPhoneNumber && smsSubscriptionState && numberChanged) {
                    yield put(setSMSUpdatesActn(optimizedPayload));
                  }
                }
              }
            }
            yield fork(
              callUpdateRTPS,
              'SPC',
              '',
              '',
              isVenmoInProgress,
              rtpsAddressObject,
              rtpsPhone,
              rtpsEmailAddress
            );
          } catch (e) {
            logger.error(e);
            yield put(BAG_PAGE_ACTIONS.resetNonCacheBagLoadingState());
          }
        }
      } else {
        rtpsAddress = rtpsBillingAddress;
        rtpsAddressLine1 = rtpsBillingAddress?.address1;
        rtpsAddressLine2 = rtpsBillingAddress?.address2;
        rtpsCountry = rtpsBillingAddress?.countryCode;
        rtpsState = rtpsBillingAddress?.stateCode;
        rtpsZip = rtpsBillingAddress?.postalCode;
        rtpsCity = rtpsBillingAddress?.city;
        rtpsPhone = rtpsBillingAddress?.phone;
        rtpsEmailAddress = rtpsBillingAddress?.c_emailId;
        rtpsAddressObject = {
          ...rtpsAddress,
          addressLine1: rtpsAddressLine1,
          addressLine2: rtpsAddressLine2,
          city: rtpsCity,
          country: rtpsCountry,
          state: rtpsState,
          zipCode: rtpsZip,
        };
        yield fork(
          callUpdateRTPS,
          'SPC',
          '',
          '',
          isVenmoInProgress,
          rtpsAddressObject,
          rtpsPhone,
          rtpsEmailAddress
        );
      }
      yield put(BAG_PAGE_ACTIONS.resetNonCacheBagLoadingState());
    } else {
      yield put(
        updateSectionState({
          id: SPC_SECTION.SHIPPING,
          section: {
            isFormExpanded: false,
            isMethodAndGiftSectionVisible: false,
          },
        })
      );
    }
    performance.clearMarks(`${SUBMIT_ORDER_BUTTON_VISIBLE}:start`);
    performance.clearMarks(`${BILLING_FORM_VISIBLE}:start`);
    performance.clearMarks(`${SHIPPING_FORM_VISIBLE}:start`);
    yield put(recalibrateSectionStates());
    const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);
    const isNonceNotExpired = yield select(isVenmoNonceActive);
    if (isLoginV2FlowEnabled && isNonceNotExpired) {
      setSessionStorage({ key: 'isVenmoPayment', value: true });
    }
    if (!isLoginV2FlowEnabled) {
      yield call(initContactForm);
    }
    yield call(checkDefaultShipmentMethodsNeeded);
    yield call(getGiftWrapOptionsData);
    const shippingValues = yield select(CheckoutSelector.getShippingDestinationValues);
    yield call(validateAdress, payload.isPaypalPostBack, shippingValues, false);
    yield put(setLoaderState(false));
    const isGsOnBagSection = yield select(getGiftServiceOnBagSection);
    const hasSfsError = yield select(getSfsError);
    const currentStage = yield select(getExpandedSectionName);
    yield call(analyticsOnCheckoutPage, currentStage);
    if (
      !isGsOnBagSection &&
      ((isExpressCheckoutEnabled && hasSfsError) || sfsErrorFromGetInventory)
    ) {
      yield put(
        updateSectionState({
          id: SPC_SECTION.SHIPPING,
          section: {
            isExpanded: true,
            isFormExpanded: true,
            isMethodAndGiftSectionVisible: true,
          },
        })
      );
      if (sfsErrorFromGetInventory) {
        yield put(
          updateSectionState({
            id: SPC_SECTION.PAYMENT,
            section: {
              isExpanded: false,
              disabled: true,
            },
          })
        );
      }
    }
    yield put(setSubmitButtonState(false));
    const { isShippingSectionSaved } = yield select(getShippingSectionSavedStatus);
    if (isShippingSectionSaved) {
      yield put(showShippingMethodsInCollapsed(true));
    }
    const isDefaultApplePayEnabled = yield select(getIsDefaultApplePayAbTest);
    const billingMethod = yield select(getPaymentId);
    const isDefaultAfterPay = yield select(checkDefaultAfterPayEnabled);
    const isApplePayEligibleVal = isApplePayEligible();
    const appleClientTokenData = yield select(getAppleClientTokenData);
    const { clientToken: authorizationKey } = appleClientTokenData || {};
    const isAppleWalletSetUpVal = yield isAppleWalletSetUp(authorizationKey);
    const isAppleWallet = isApplePayEligibleVal && isAppleWalletSetUpVal;
    const isExtendedPreOrderForSpc = yield select(getIsExtendedPreOrderForSPC);
    const afterPaySS = parseBoolean(getSessionStorage('defaultAfterPay'));
    const applePayDefault = yield select(BAG_PAGE_SELECTORS.showApplePayDefault);
    const isPickupSectionSaved = !isEmpty(pickUpContactPerson?.firstName);
    const sectionSaved =
      orderType === 'PURE_BOSS' || orderType === 'PURE_BOPIS'
        ? isPickupSectionSaved
        : orderType === 'ECOM_MIX'
        ? isPickupSectionSaved && isShippingSectionSaved
        : isShippingSectionSaved;
    const isExpressAfterPayFlow = yield select(CheckoutSelector.isExpressAfterPayFlow);
    if (
      sectionSaved &&
      isDefaultApplePayEnabled &&
      !isExpressCheckoutEnabled &&
      !billingMethod &&
      !isDefaultAfterPay &&
      !afterPaySS &&
      isAppleWallet &&
      !isExtendedPreOrderForSpc &&
      !isCanada() &&
      applePayDefault &&
      !isExpressAfterPayFlow
    ) {
      yield put(BagPageActions.setPaymentMethod('APPLE_PAY'));
      yield put(
        updateSectionState({
          id: SPC_SECTION.PAYMENT,
          section: {
            isExpanded: false,
            mode: SECTION_MODE.SECTION_VIEW_MODE,
          },
        })
      );
    }
  } catch (e) {
    yield put(
      updateSectionState({
        id: SPC_SECTION.SHIPPING,
        section: {
          disabled: false,
          isExpanded: true,
          isFormExpanded: true,
          isMethodAndGiftSectionVisible: true,
        },
      })
    );
    logger.error({
      error: 'Error in initSinglePageCheckout',
      extraData: {
        errorMessage: JSON.stringify(e),
        component: 'SinglePageCheckoutSaga',
        methodName: 'initSinglePageCheckout',
      },
    });
  }
}

function* submitShippingSectionData(submitButtonId, savingContactSection) {
  try {
    yield put(setLoaderState(true));
    yield put(setSpcButtonLoader({ id: submitButtonId, isLoading: true }));
    yield put(setServerErrorCheckout({}));
    const isGuestUser = yield select(isGuest);
    const reduxState = yield select();
    const loggedInUserEmail = yield select(getUserEmail);
    const loggedInUserPhone = yield select(getUserPhoneNumber);
    const { phoneNumber: orderPhoneNo, emailAddress: orderEmail } =
      CheckoutSelector.getShippingPhoneAndEmail(reduxState) || {};
    const contactSectionData = getSinglePageCheckoutSectionState()(reduxState, SPC_SECTION.CONTACT);
    const shippingSectionData = getSinglePageCheckoutSectionState()(
      reduxState,
      SPC_SECTION.SHIPPING
    );
    const shippingMethodfromBag = yield select(BAG_PAGE_SELECTORS.getShippingMethodID);
    const { savedContactInfo, smsSignUp, emailSignUp } = contactSectionData;
    const contactDetail = yield select(getSavedContactDetails);
    const {
      savedAddress: shippingSectionSavedData,
      shipmentMethods,
      giftServicesDetails,
      isExpanded,
      emailSignUp: shippingEmailSignUp,
    } = shippingSectionData;
    const activeEmailSignUp = isExpanded ? shippingEmailSignUp : emailSignUp;
    const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);
    const modifiedShippingMethod = shipmentMethods?.shippingMethodId
      ? shipmentMethods?.shippingMethodId
      : shippingMethodfromBag;
    const smsSignUpFromSection = isLoginV2FlowEnabled ? shippingSectionData?.smsSignUp : smsSignUp;
    const checkoutShippingAddress = yield select(CheckoutSelector.getShippingAddress);
    let savedAddress = shippingSectionSavedData;
    if (!savedAddress?.addressLine1 && checkoutShippingAddress?.addressLine1) {
      savedAddress = checkoutShippingAddress;
    }
    const shippingPayload = getShippingPayloadForSubmit({
      savedAddress,
      savedContactInfo,
      giftServicesDetails,
      isGuestUser,
      modifiedShippingMethod,
      smsSignUpFromSection,
      emailSignUp: activeEmailSignUp,
      loggedInUserEmail,
      loggedInUserPhone,
      orderPhoneNo,
      contactDetail,
      isLoginV2FlowEnabled,
      orderEmail,
      contactSectionData,
      checkoutShippingAddress,
    });
    yield put(clearEddTTL());
    yield call(submitShipping, { ...shippingPayload, savingContactSection, submitButtonId });
    const isEcomOrder = yield select(isECOMStatus);
    const isMixedOrder = yield select(isMixedOrderStatus);
    if (isEcomOrder) {
      yield call(
        startCheckoutAnalytics,
        constants.CHECKOUT_STAGES.BILLING,
        false,
        isLoginV2FlowEnabled
      );
    } else if (isMixedOrder) {
      yield call(
        startCheckoutAnalytics,
        constants.CHECKOUT_STAGES.PICKUP,
        false,
        isLoginV2FlowEnabled
      );
    }
  } catch (e) {
    yield call(handleShippingError, e);
    yield put(setLoaderState(false));
    yield put(setSpcButtonLoader({ id: submitButtonId, isLoading: false }));
  }
}

export function* saveAndContinuePayment({ payload = {} }) {
  try {
    const skipPayment = yield select(shouldSkipPayment);
    const isGuestUser = yield select(isGuest);
    const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);
    const {
      cardNumber: formattedCardNumber = '',
      expMonthAndYear,
      address = {},
      isPLCC,
      onFileCardId,
      saveToAccount,
      cardType,
      isDefault,
      paymentAction,
      recaptchaToken,
      differentCardSelectedFromList = false,
    } = payload;
    let cardOtherDetails = {};
    const cardNumber = formattedCardNumber.replace(/ /g, ''); // Removing all spaces those were introduced due to card number formatting.
    if (skipPayment) {
      yield call(updateSectionStateOnGetCart);
    } else {
      if (!isPLCC) {
        const [expMonth, expYear] = extractMonthAndYear(expMonthAndYear);
        cardOtherDetails = {
          expMonth,
          expYear,
          cvv: payload.cvv,
          cardType,
        };
      }

      const billingPayload = {
        cardNumber,
        ...cardOtherDetails,
        onFileCardId,
        address: deStructureAddress(address),
        isPLCC,
        saveToAccount,
        isDefault,
        callFetchAddresses: false,
        paymentAction,
        differentCardSelectedFromList,
        recaptchaToken,
      };
      const isTriggerCheckoutWithPaymentEnabled = yield select(getTriggerCheckoutWithPayment);

      yield put(setLoaderState(true));
      yield put(setSpcButtonLoader({ id: SPC_BUTTON.SAVE_PAYMENT, isLoading: true }));
      yield put(setServerErrorCheckout({}));
      yield call(submitBilling, { payload: billingPayload, propagateError: true });
      if (isTriggerCheckoutWithPaymentEnabled)
        yield put(setSpcButtonLoader({ id: SPC_BUTTON.SUBMIT_ORDER, isLoading: true }));
      yield put(recalibrateSectionStates());
      yield put(setLoaderState(false));
      yield put(setSpcButtonLoader({ id: SPC_BUTTON.SAVE_PAYMENT, isLoading: false }));

      if (!isGuestUser && saveToAccount) {
        yield call(getCardList, { ignoreCache: true });
      }

      let fetchAddressBook = false;
      const { sameAsShipping } = billingPayload.address;
      if (!sameAsShipping) {
        fetchAddressBook = true;
      }
      if (!isGuestUser && fetchAddressBook) {
        yield call(getAddressList);
      }
    }

    const isPersistEddEnabledGlobal = yield select(isPersistEddGlobalEnabled);
    if (isPersistEddEnabledGlobal) {
      yield fork(callPersistData);
    }

    const isTriggerCheckoutWithPaymentEnabled = yield select(getTriggerCheckoutWithPayment);
    if (isTriggerCheckoutWithPaymentEnabled) {
      yield call(submitOrderForProcessing, {
        payload: {
          hideLoader: true,
        },
      });
      yield put(triggerCheckoutWithPayment(false));
    }
    yield call(
      startCheckoutAnalytics,
      constants.CHECKOUT_STAGES.REVIEW,
      false,
      isLoginV2FlowEnabled
    );
    yield put(setApplePayDefault(false));
    if (payload?.isPLCC || payload?.cardNumber) {
      pushEventToAdobeAnalytics('checkout_page_billing_start', payload?.isPLCC ? 'PLCC' : 'Card');
    }
    removeSessionStorage('defaultAfterPay');
    const isSuppressCvvFieldEnabled = yield select(getSuppressCvvField);
    if (isSuppressCvvFieldEnabled) {
      yield put(setSuppressCCheck(false));
    }
  } catch (e) {
    logger.error(e);
    yield put(setLoaderState(false));
    yield put(setSpcButtonLoader({ id: SPC_BUTTON.SAVE_PAYMENT, isLoading: false }));
    yield put(triggerCheckoutWithPayment(false));
  }
}

function* handleSaveAddressFromMelissa({ payload }) {
  const {
    addressId,
    address1: addressLine1,
    address2: addressLine2,
    city,
    country,
    postalCode,
    stateCode,
    countryCode,
  } = payload;
  const {
    firstName,
    formName,
    isCommercialAddress,
    lastName,
    primary,
    state,
    validationCode,
    zip: zipCode,
    saveToAddressBook,
    defaultShipping,
    giftServicesDetails,
    shipmentMethods,
    submitButtonId,
    savingContactSection,
    allowSubmitShipping = true,
    smsSignUp,
    phoneNumber,
    emailAddress,
    phoneCountryCode,
  } = payload;
  const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);
  if (allowSubmitShipping) {
    if (isLoginV2FlowEnabled) {
      yield put(
        updateSectionState({
          id: SPC_SECTION.SHIPPING,
          section: {
            savedAddress: {
              addressId,
              firstName,
              lastName,
              addressLine1,
              addressLine2,
              city,
              state: stateCode || state,
              country: countryCode || country,
              zipCode: postalCode || zipCode,
              formName,
              isCommercialAddress,
              primary,
              validationCode,
              saveToAddressBook,
              defaultShipping,
              phoneNumber,
              emailAddress,
              phoneCountryCode,
            },
            giftServicesDetails: { ...giftServicesDetails },
            shipmentMethods,
            smsSignUp,
          },
        })
      );
    } else {
      yield put(
        updateSectionState({
          id: SPC_SECTION.SHIPPING,
          section: {
            savedAddress: {
              addressId,
              firstName,
              lastName,
              addressLine1,
              addressLine2,
              city,
              state,
              country,
              zipCode,
              formName,
              isCommercialAddress,
              primary,
              validationCode,
              saveToAddressBook,
              defaultShipping,
              phoneCountryCode,
            },
            giftServicesDetails: { ...giftServicesDetails },
            shipmentMethods,
          },
        })
      );
    }
    yield call(
      submitShippingSectionData,
      submitButtonId || SPC_BUTTON.SAVE_SHIPPING,
      savingContactSection
    );
    const isDefaultAfterPay = yield select(checkDefaultAfterPayEnabled);

    const isExpressCheckoutEnabled = yield select(isExpressCheckout);
    const isDefaultApplePayEnabled = yield select(getIsDefaultApplePayAbTest);
    const orderTrackingEnhancementEnabled = yield select(getOrderTrackingEnhancementEnabled);
    if (orderTrackingEnhancementEnabled) {
      yield put(
        updateSectionState({
          id: SPC_SECTION.SHIPPING,
          section: {
            isFormExpanded: false,
            registeredUserFormMode: REG_FORM_MODE.SAVED_ADDRESS,
          },
        })
      );
    }
    const billingMethod = yield select(getPaymentId);
    const isApplePayEligibleVal = isApplePayEligible();
    const appleClientTokenData = yield select(getAppleClientTokenData);
    const { clientToken: authorizationKey } = appleClientTokenData || {};
    const isAppleWalletSetUpVal = yield isAppleWalletSetUp(authorizationKey);
    const isAppleWallet = isApplePayEligibleVal && isAppleWalletSetUpVal;
    const isExtendedPreOrderForSpc = yield select(getIsExtendedPreOrderForSPC);
    const afterPaySS = parseBoolean(getSessionStorage('defaultAfterPay'));
    const applePayDefault = yield select(BAG_PAGE_SELECTORS.showApplePayDefault);
    if (
      isDefaultApplePayEnabled &&
      !isExpressCheckoutEnabled &&
      isAppleWallet &&
      !billingMethod &&
      !isDefaultAfterPay &&
      !isExtendedPreOrderForSpc &&
      !isCanada() &&
      applePayDefault &&
      !afterPaySS
    ) {
      yield put(BagPageActions.setPaymentMethod('APPLE_PAY'));
      yield put(
        updateSectionState({
          id: SPC_SECTION.PAYMENT,
          section: {
            isExpanded: false,
            mode: SECTION_MODE.SECTION_VIEW_MODE,
          },
        })
      );
    }
  }
}

function* saveContact({ payload }) {
  const { savedContactInfo, smsSignUp, emailSignUp } = payload;
  const { isShippingSectionSaved } = yield select(getShippingSectionSavedStatus);

  if (isShippingSectionSaved) {
    yield put(
      updateSectionState({
        id: SPC_SECTION.CONTACT,
        section: { savedContactInfo, smsSignUp, emailSignUp },
      })
    );
    const values = yield call(getSavedShippingValues);
    yield call(handleSaveAddressFromMelissa, {
      payload: { ...values, submitButtonId: SPC_BUTTON.SAVE_CONTACT, savingContactSection: true },
    });
  } else {
    addPerformanceMarksForSection(SHIPPING_FORM_VISIBLE);
    savedContactInfo.emailAddress =
      savedContactInfo.emailAddress === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email
        ? ''
        : savedContactInfo.emailAddress;
    savedContactInfo.phoneNumber =
      savedContactInfo.phoneNumber === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone
        ? ''
        : savedContactInfo.phoneNumber;
    yield put(
      updateSectionState({
        id: SPC_SECTION.CONTACT,
        section: { isExpanded: false, savedContactInfo, smsSignUp, emailSignUp },
      })
    );
  }
  savedContactInfo.emailAddress =
    savedContactInfo.emailAddress === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email
      ? ''
      : savedContactInfo.emailAddress;
  savedContactInfo.phoneNumber =
    savedContactInfo.phoneNumber === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone
      ? ''
      : savedContactInfo.phoneNumber;
  savedContactInfo.smsSignUp = smsSignUp;
  savedContactInfo.emailSignUp = emailSignUp;
  setContactFormValuesInSS({ ...savedContactInfo });
  const isEcomOrder = yield select(isECOMStatus);
  const isMixedOrder = yield select(isMixedOrderStatus);
  const isBossBopisOrder = yield select(isPickuOrderStatus);
  if (isEcomOrder || isMixedOrder)
    yield call(startCheckoutAnalytics, constants.CHECKOUT_STAGES.SHIPPING, false);
  else if (isBossBopisOrder)
    yield call(startCheckoutAnalytics, constants.CHECKOUT_STAGES.PICKUP, false);
  yield put(recalibrateSectionStates());
}

function* fetchCvvInfoModuleX({ payload }) {
  try {
    const result = yield call(getModuleX, payload);
    yield put(setCvvInfoModuleX(result?.richText));
  } catch (err) {
    logger.error(err);
  }
}

export function* fetchGiftDetailsModalModuleX({ payload }) {
  try {
    const [tcpContent, gymContent, snjContent, pjpContent] = yield all([
      call(getModuleX, payload?.[0]?.contentId),
      call(getModuleX, payload?.[1]?.contentId),
      call(getModuleX, payload?.[2]?.contentId),
      call(getModuleX, payload?.[5]?.contentId),
    ]);
    const giftServices = {
      giftDetailsModalModuleXContent: tcpContent?.richText,
      giftDetailsGymModalModuleXContent: gymContent?.richText,
      giftDetailsSnjModalModuleXContent: snjContent?.richText,
      giftDetailsPjpModalModuleXContent: pjpContent?.richText,
    };
    yield put(setGiftDetailsModalContentModuleX(giftServices));
  } catch (err) {
    logger.error(err);
  }
}

function* saveAndContinueShipping({ payload }) {
  const { savedAddress, fromShippingCollapsedSection, ...otherProps } = payload;
  const { smsSignUp, emailSignUp, phoneNumber } = savedAddress;
  const afterPayPayload = yield select(getAfterPayPayload);
  if (afterPayPayload?.isMallisaFailed) {
    const updatedPayload = { ...afterPayPayload, isPayloadChanged: true };
    yield AddressVerificationDynamicStore();
    yield put(resetAfterPayPayload(updatedPayload));
  }
  yield put(setIsUpdatingShipmentMethods(true));
  yield put(setSFSErrors(null));
  const meslissaPayload = formatPayloadForMelissa({
    ...savedAddress,
    ...otherProps,
    formName: SHIPPING_FORM_NAME,
  });

  if (fromShippingCollapsedSection) {
    yield call(handleSaveAddressFromMelissa, {
      payload: { ...meslissaPayload, submitButtonId: SPC_BUTTON.SAVE_SHIPPING },
    });
  } else {
    yield put(setShowAddressVerification(true));
    yield put(verifyAddress(meslissaPayload));
  }
  yield put(getSetIsPaypalPaymentSettings(null)); // To reinitialize paypal settings after shipping address update
  const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);
  if (isLoginV2FlowEnabled) {
    yield put(
      updateSectionState({
        id: SPC_SECTION.SHIPPING,
        section: { smsSignUp, emailSignUp, phoneNumber },
      })
    );
    setShippingFormValuesInSS({ smsSignUp, emailSignUp, phoneNumber });
  }
}

export function* submitOrderWithPayment({ payload }) {
  try {
    const isVisible = yield select(isCvvVisibleOnViewMode);
    const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);

    yield put(setLoaderState(true));
    yield put(updateSubmitOrderButtonState(SUBMIT_ORDER_BUTTON_STATE.LOADING));
    yield put(setSpcButtonLoader({ id: SPC_BUTTON.SUBMIT_ORDER, isLoading: true }));
    if (isVisible) {
      const { billing, address } = yield select(CheckoutSelector.getBillingValues);
      const billingPayload = {
        address,
        ...billing,
        cvv: payload.cvvCode,
        callFetchAddresses: false,
      };

      yield call(submitBilling, { payload: billingPayload, propagateError: true });
    }
    yield put(updateSubmitOrderButtonState(SUBMIT_ORDER_BUTTON_STATE.NORMAL));
    yield call(submitOrderForProcessing, {
      payload: {
        hideLoader: true,
        navigation: payload?.navigation || {},
        callback: payload?.callback,
      },
    });
    yield put(setLoaderState(false));
    yield put(updateSubmitOrderButtonState(SUBMIT_ORDER_BUTTON_STATE.SUCCESS));
    yield put(setSpcButtonLoader({ id: SPC_BUTTON.SUBMIT_ORDER, isLoading: false }));
    if (!isLoginV2FlowEnabled) {
      removeSessionStorage(CONTACT_FORM);
    }
  } catch (e) {
    yield put(setLoaderState(false));
    yield put(updateSubmitOrderButtonState(SUBMIT_ORDER_BUTTON_STATE.NORMAL));
    yield put(setSpcButtonLoader({ id: SPC_BUTTON.SUBMIT_ORDER, isLoading: false }));
    logger.error(e);
  }
}

export function* addEditStoreDetails({ payload }) {
  try {
    yield put(setLoaderState(true));
    const basketId = getBasketId();
    yield put(setSpcButtonLoader({ id: SPC_BUTTON.SAVE_PICKUP, isLoading: true }));
    yield put(setServerErrorCheckout({}));
    const errorMapping = yield select(BAG_PAGE_SELECTORS.getErrorMapping);
    const res = yield call(addEditStoreDetailsApi, { ...payload, basketId }, errorMapping);
    if (res) {
      yield put(toggleVerifyCvvModal(true));
      yield call(processMutationNonCachedDataSaga, {
        payload: {
          respToProcess: res?.storeDetails,
          isCheckoutFlow: true,
        },
      });

      // eslint-disable-next-line sonarjs/no-identical-functions
      const store = res?.storeDetails?.shipments?.filter((data) => {
        if (data?.shipmentId !== 'me' && data?.itemsCount > 0) {
          return data;
        }
        return null;
      });

      const shippingData = res?.storeDetails?.shipments?.filter((data) => {
        if (data?.shipmentId === 'me' && data?.itemsCount > 0) {
          return data;
        }
        return null;
      });

      const [shipment = {}] = store;
      const [shipmentValue = {}] = shippingData;

      const orderType = yield select(getOrderType);
      const isMixedOrder = orderType === 'ECOM_MIX';

      const normalizedPhoneNumberPickUp = shipment?.shippingAddress?.phone?.replace(/\D/g, '');
      const normalizedPhoneNumberShipping = shipmentValue?.shippingAddress?.phone?.replace(
        /\D/g,
        ''
      );

      let phoneNumberValue = normalizedPhoneNumberPickUp;
      const shipmentIdValue = shipment?.shipmentId;

      const subscribedPhoneNumber = readCookie('subscribedPhoneNumber');
      const unsubscribedPhoneNumber =
        readCookie('unsubscribedPhoneNumber') === 'null'
          ? false
          : readCookie('unsubscribedPhoneNumber');
      const smsSubscriptionStatus = parseBoolean(readCookie('smsSubscriptionStatus')) || false;

      const isUSorCaCountryCode =
        shipmentValue?.shippingAddress?.c_phoneCountryCode === '+1' ||
        shipmentValue?.shippingAddress?.c_phoneCountryCode === null ||
        shipmentValue?.shippingAddress?.c_phoneCountryCode === undefined;

      const isUSorCaCountryCodePickup =
        shipment?.shippingAddress?.c_phoneCountryCode === '+1' ||
        shipment?.shippingAddress?.c_phoneCountryCode === null ||
        shipment?.shippingAddress?.c_phoneCountryCode === undefined;

      const isSMSUpdatesSingleOptInEnabled = yield select(getSMSUpdatesSingleOptInEnabled);

      if (
        smsSubscriptionStatus &&
        !isUSorCaCountryCodePickup &&
        !isUSorCaCountryCode &&
        isSMSUpdatesSingleOptInEnabled
      ) {
        setCookie({
          key: 'smsSubscriptionStatus',
          value: false,
        });
        setCookie({
          key: 'subscribedPhoneNumber',
          value: null,
        });
      }
      const shippingNumber = isUSorCaCountryCode ? normalizedPhoneNumberShipping : null;
      phoneNumberValue =
        !isUSorCaCountryCodePickup && isMixedOrder ? shippingNumber : phoneNumberValue;

      const subscribedNewPhoneNumber =
        (phoneNumberValue !== subscribedPhoneNumber &&
          phoneNumberValue !== unsubscribedPhoneNumber) ||
        (unsubscribedPhoneNumber &&
          phoneNumberValue !== unsubscribedPhoneNumber &&
          !smsSubscriptionStatus);

      if (subscribedNewPhoneNumber && isSMSUpdatesSingleOptInEnabled) {
        let smsResponse = yield call(getTransSmsSubscriptionStateSaga, phoneNumberValue);
        let smsSubscriptionState = smsResponse?.data?.getTransSmsSubscriptionState?.status;
        if (
          isMixedOrder &&
          !smsSubscriptionState &&
          normalizedPhoneNumberShipping &&
          isUSorCaCountryCode
        ) {
          smsResponse = yield call(getTransSmsSubscriptionStateSaga, normalizedPhoneNumberShipping);
          smsSubscriptionState = smsResponse?.data?.getTransSmsSubscriptionState?.status;
          if (smsSubscriptionState) {
            phoneNumberValue = normalizedPhoneNumberShipping;
          }
        }
        setCookie({
          key: 'smsSubscriptionStatus',
          value: smsSubscriptionState,
        });
        if (smsSubscriptionState) {
          setCookie({
            key: 'subscribedPhoneNumber',
            value: phoneNumberValue,
          });
          setCookie({
            key: 'unsubscribedPhoneNumber',
            value: null,
          });
        } else {
          setCookie({
            key: 'unsubscribedPhoneNumber',
            value: phoneNumberValue,
          });
        }
        const optimizedPayload = [
          {
            shipmentId: shipmentIdValue,
            c_vibesSmsPhoneNo: phoneNumberValue || '',
          },
        ];
        const numberChanged = subscribedPhoneNumber
          ? subscribedPhoneNumber !== phoneNumberValue
          : false;

        // call sms order updates api when number is changed but this also is subscribed, we need to send this new number to Vibes
        if (subscribedNewPhoneNumber && smsSubscriptionState && numberChanged) {
          yield put(setSMSUpdatesActn(optimizedPayload));
        }
      }

      yield put(setLoaderState(false));
      const smsInfo = JSON.stringify(payload?.smsSignUp?.sendOrderUpdate) === 'true';
      const pickupContectDetails = {
        firstName:
          payload?.firstName === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.firstName
            ? null
            : payload?.firstName,
        lastName:
          payload?.lastName === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.lastName
            ? null
            : payload?.lastName,
        emailAddress:
          payload?.email === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email ? null : payload?.email,
        phoneNumber:
          payload?.phone === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone ? null : payload?.phone,
        phoneCountryCode: payload?.phoneCountryCode,
      };
      const pickupContactDetailsNew = {
        firstName:
          payload?.firstName === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.firstName
            ? null
            : payload?.firstName,
        lastName:
          payload?.lastName === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.lastName
            ? null
            : payload?.lastName,
        emailAddress:
          payload?.email === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email ? null : payload?.email,
        phoneNumber:
          payload?.phone === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone ? null : payload?.phone,
        smsSignUp: { sendOrderUpdate: smsInfo },
        phoneCountryCode: payload?.phoneCountryCode,
      };
      const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);
      const PickupPayload = isLoginV2FlowEnabled ? pickupContactDetailsNew : pickupContectDetails;
      yield put(getSetPickupValuesActn(PickupPayload));

      const altPersonDetailsObj = {
        firstName: payload.c_altFirstName,
        lastName: payload.c_altLastName,
        emailAddress: payload.c_altEmail,
      };
      yield put(getSetPickupAltValuesActn(altPersonDetailsObj));
      yield put(setSpcButtonLoader({ id: SPC_BUTTON.SAVE_PICKUP, isLoading: false }));
      yield call(
        startCheckoutAnalytics,
        constants.CHECKOUT_STAGES.BILLING,
        false,
        isLoginV2FlowEnabled
      );

      yield put(recalibrateSectionStates());
    } else {
      yield put(setLoaderState(false));
      yield put(setSpcButtonLoader({ id: SPC_BUTTON.SAVE_PICKUP, isLoading: false }));
    }
    const isDefaultApplePayEnabled = yield select(getIsDefaultApplePayAbTest);
    const isExpressCheckoutEnabled = yield select(isExpressCheckout);
    const isDefaultAfterPay = yield select(checkDefaultAfterPayEnabled);
    if (!payload.isUpdating) {
      yield call(setAfterPayPaymentmethod);
    }
    const isApplePayEligibleVal = isApplePayEligible();
    const appleClientTokenData = yield select(getAppleClientTokenData);
    const { clientToken: authorizationKey } = appleClientTokenData || {};
    const isAppleWalletSetUpVal = yield isAppleWalletSetUp(authorizationKey);
    const isAppleWallet = isApplePayEligibleVal && isAppleWalletSetUpVal;
    const afterPaySS = parseBoolean(getSessionStorage('defaultAfterPay'));
    const applePayDefault = yield select(BAG_PAGE_SELECTORS.showApplePayDefault);
    const isExtendedPreOrderForSpc = yield select(getIsExtendedPreOrderForSPC);
    if (
      isDefaultApplePayEnabled &&
      !isExpressCheckoutEnabled &&
      isAppleWallet &&
      !isDefaultAfterPay &&
      !isCanada() &&
      applePayDefault &&
      !afterPaySS &&
      !isExtendedPreOrderForSpc
    ) {
      yield put(BagPageActions.setPaymentMethod('APPLE_PAY'));
      yield put(
        updateSectionState({
          id: SPC_SECTION.PAYMENT,
          section: {
            isExpanded: false,
            mode: SECTION_MODE.SECTION_VIEW_MODE,
          },
        })
      );
    }

    yield put(isPlccIsPickupModalOpen(false));
    const { emailSignUp, email } = payload;
    if (email && emailSignUp?.emailSignUp) {
      yield submitEmailSignup(email, emailSignUp.emailSignUp);
    }
  } catch (e) {
    yield put(setLoaderState(false));
    yield put(setSpcButtonLoader({ id: SPC_BUTTON.SAVE_PICKUP, isLoading: false }));
    const errorMessage = e?.errorMessages?._error || constants.SOMETHING_WENT_WRONG;
    if (errorMessage) {
      yield put(setServerErrorCheckout({ errorMessage, component: 'PAGE' }));
    }
    logger.error(e);
    yield put(isPlccIsPickupModalOpen(false));
  }
}

const removeSfsErrorsLocalStorage = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem('sfsError');
  }
};

export function* moveSFSItemsToSFLSaga({ payload }) {
  try {
    yield put(setLoaderState(true));
    const errorMapping = yield select(BAG_PAGE_SELECTORS.getErrorMapping);
    const response = yield call(moveSFSItemsToSFL, payload, errorMapping);
    const { message = '', sflListId = '' } = response || {};
    if (message === 'success') {
      yield put(setSFSErrors(null));
      removeSfsErrorsLocalStorage();
      yield put(setSflId(sflListId));
      yield put(moveItemToSFLToggle(true));
      const isRegistered = yield select(getUserLoggedInState);
      if (!isRegistered) {
        setSessionStorage({ key: 'SFL_ID', value: JSON.stringify(sflListId) });
      }
      yield call(resetCartCache);
      yield call(getCachedCartDataSaga, {
        payload: {
          isCheckoutFlow: true,
          ignoreCartLoader: true,
        },
      });
      yield put(BAG_PAGE_ACTIONS.setGetCartItemComplete());
      yield put(BAG_PAGE_ACTIONS.getSflData());
      const itemsCount = yield select(BAG_PAGE_SELECTORS.getTotalItems);
      if (itemsCount === 0) {
        routerPush('/bag', '/bag');
        yield put(setLoaderState(false));
        return;
      }
      yield call(getNonCachedCartDataSaga, {
        payload: {
          isCheckoutFlow: true,
        },
      });
      yield put(BAG_PAGE_ACTIONS.setGetCartDetailComplete());
      yield put(moveItemToSFLToggle(false));
      setValueInAsyncStorage('SFL_ID', JSON.stringify(sflListId));
    }
    yield put(setLoaderState(false));
  } catch (e) {
    yield put(setLoaderState(false));
    yield put(moveItemToSFLToggle(false));
    yield put(
      setServerErrorCheckout({ errorMessage: e?.errorMessages?._error, component: 'PAGE' })
    );
    logger.error(e);
  }
}

function* SinglePageCheckoutSaga() {
  yield takeLatest(INIT_EDD, initEdd);
  yield takeLatest(INIT_SINGLE_PAGE_CHECKOUT_PAGE, initSinglePageCheckout);
  yield takeLatest(FETCH_CVV_MODULE_X, fetchCvvInfoModuleX);
  yield takeLatest(FETCH_GIFT_DETAIL_MODAL_MODULE_X, fetchGiftDetailsModalModuleX);
  yield takeLatest(SAVE_AND_CONTINUE_SHIPPING, saveAndContinueShipping);
  yield takeLatest(SAVE_ADDRESS_FROM_MELISSA, handleSaveAddressFromMelissa);
  yield takeLatest(SAVE_AND_CONTINUE_PAYMENT, saveAndContinuePayment);
  yield takeLatest(RECALIBRATE_SECTIONS_STATES, updateSectionStateOnGetCart);
  yield takeLatest(SUBMIT_ORDER_WITH_PAYMENT, submitOrderWithPayment);
  yield takeLatest(SAVE_SPC_CONTACT, saveContact);
  yield takeLatest(ACTIVATE_SPC_SECTION, activateSpcSection);
  yield takeLatest(ADD_EDIT_STORE_DETAILS, addEditStoreDetails);
  yield takeLatest(ADD_SFS_ITEMS_TO_SFL, moveSFSItemsToSFLSaga);
}

export default SinglePageCheckoutSaga;
